export const MenuCategory = {
  Dashboard: 0,
  UserManagement: 1,
  ClientConfiguration: 2,
  Search: 3,
  Jobs: 4,
  Events: 5,
  Reports: 6,
  CrossClient: 7,
  MoreApps: 8,
  Profile: 9,
  ABAC: 10,
};
